<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">SMS(문자메시지)</span>
            <span class="txt">센터가 승인 요청한 SMS 발신번호를 확인하고 관리할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <button @click="onClickRouter('/madmin/business/smsNumSetting')">SMS 발신번호 관리</button>
            <button class="on">SMS 결제내역</button>
            <button @click="onClickRouter('/madmin/business/adminRefuseNum')">수신거부번호</button>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['기간선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="검색어를 입력해 주세요"
                        type="text"
                        @keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>

        <div class="com-table-content com-msg-content">
            <div class="table-header com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="getExcel">엑셀 다운로드</button>
                </div>
                <div class="right-box">
                    <span class="txt">
                        총
                        <span class="blue">{{ paymentList.count }}</span>
                        건
                    </span>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col />
                    <col style="width: 250px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 420px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col />
                    <col />
                </colgroup>
                <thead>
                    <tr>
                        <th>센터명</th>
                        <th>결제일시</th>
                        <th>충전금액</th>
                        <th>차감금액</th>
                        <th>메모</th>
                        <th>잔여금액</th>
                        <th>비고</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in paymentList.list" :key="index">
                        <td>{{ item.centerName }}</td>
                        <td>{{ item.displayDate }}</td>
                        <td>{{ item.cost !== null ? formatNumber(item.cost) + '원' : '' }}</td>
                        <td>{{ item.charged_point !== null ? formatNumber(item.charged_point) + '원' : '' }}</td>
                        <td>{{ item.memo }}</td>
                        <td>{{ item.point !== null ? formatNumber(item.point) + '원' : '' }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.skip"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import { pagingInfo } from '@/assets/js/common';
import paymentApi from '@/assets/js/paymentApi';
import moment from 'moment';
import XLSX from 'xlsx';
import EventBus from '../../../assets/js/eventBus';
export default {
    name: 'messageHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        period(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.paymentHistory();
        },
        startDate(newValue) {
            this.startDate = newValue;
            console.log('startDate', this.startDate);
        },
        endDate(newValue) {
            this.endDate = newValue;
            console.log('endDate', this.endDate);
        },
        searchSmsType(newValue) {
            this.searchSmsType = newValue;
            this.paymentHistory();
        },
        sendOk(newValue) {
            this.sendOk = newValue;
            this.paymentHistory();
        },
        sender(newValue) {
            this.sender = newValue;
            this.paymentHistory();
        },
    },
    data() {
        return {
            fileViewPop: false,
            centerId: '',
            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            pagingInfo: { ...pagingInfo },
            searchStr: '',
            period: '',
            historyList: [],
            searchSmsType: '',
            sendOk: '',
            sender: '',
            requestListData: [],
            selectedImageUrl: null,
            paymentList: [],
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터id
        this.init();
    },
    filters: {
        formatDate(value) {
            if (value) {
                const date = new Date(value);
                const year = date.getFullYear();
                const month = ('0' + (date.getMonth() + 1)).slice(-2);
                const day = ('0' + date.getDate()).slice(-2);
                return `${year}-${month}-${day}`;
            }
            return '';
        },
    },
    methods: {
        // 초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.skip = 10;
            this.pagingInfo.totalItems = this.paymentList.count;
            this.paymentHistory();
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        },
        async paymentHistory() {
            const response = await paymentApi.post(`/admin/api/admin-management-center/handling-center-point-history`, {
                page: this.pagingInfo.page,
                skip: this.pagingInfo.skip,
                startDate: this.startDate,
                endDate: this.endDate,
                centerName: this.centerName,
            });

            // 날짜 포맷팅 함수 추가
            const formatCreatedAt = (createdAt) => {
                const date = new Date(createdAt);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hour = String(date.getHours()).padStart(2, '0');
                const minute = String(date.getMinutes()).padStart(2, '0');
                const second = String(date.getSeconds()).padStart(2, '0');
                return `${year}년 ${month}월 ${day}일 ${hour}: ${minute}: ${second}`;
            };

            // combinedList의 날짜 포맷팅
            const combinedList = response.data.list.map((item) => ({
                ...item,
                displayDate: formatCreatedAt(item.created_at),
                cost: item.cost !== null ? parseInt(item.cost, 10) : null, // 숫자 형식으로 변환
            }));

            // 최신 날짜순으로 정렬
            combinedList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            // paymentList 업데이트
            this.paymentList = {
                list: combinedList,
                count: response.data.count,
            };

            // 총 아이템 수 업데이트
            this.pagingInfo.totalItems = this.paymentList.count;

            console.log('paymentList', this.paymentList);
        },

        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
            return startDate;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.paymentHistory();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.paymentHistory();
        },
        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = '';
            (this.searchSmsType = ''), (this.searchStr = '');
            this.paymentHistory();
            EventBus.$emit('event:init', 'init');
        },
        // 검색어 입력
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.centerName = this.searchStr;
            console.log('centerName', this.centerName);
            this.paymentHistory();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.skip = val;
            this.paymentHistory();
        },

        getExcel() {
            const dataWS = XLSX.utils.json_to_sheet(this.historyList);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, 'sendHistory');
            XLSX.writeFile(wb, 'sendHistory.xlsx');
        },

        // 예시: 날짜 포맷팅 메소드 수정
        formatHistoryDate(dateString) {
            const date = new Date(dateString);

            // 날짜와 시간 포맷팅 옵션 설정
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
            };

            // toLocaleDateString을 사용하여 날짜 포맷팅
            let formattedDate = date.toLocaleDateString('ko-KR', options);

            // '일 ' 뒤에 공백을 추가하여 표시
            return formattedDate.replace('일 ', '일 ');
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.paymentHistory();
        },
    },
};
</script>
<style lang="scss"></style>
